<jhi-page-ribbon></jhi-page-ribbon>

<fw-router-outlet></fw-router-outlet>

<router-outlet name="popup"></router-outlet>

<fw-confirm-update-toast></fw-confirm-update-toast>
